import { LegalLayout } from "./legal-layout";
import { LegalSection } from "./legal-section";
import { LAST_UPDATED, CONTACT_EMAIL } from "./constants";

export function PrivacyPage() {
  return (
    <LegalLayout title="Политика за поверителност" lastUpdated={LAST_UPDATED}>
      <p>
        Поверителността Ви е важна за нас. Тази политика обяснява какви данни
        събираме и как ги използваме, когато ползвате играта (наричана
        по-нататък „Услугата“).
      </p>

      <LegalSection heading="1. Какви данни събираме">
        <p>
          При влизане чрез Google събираме основна профилна информация (име,
          имейл, профилна снимка). Съхраняваме и игрови данни като резултати,
          статистика и история на изиграните пъзели.
        </p>
      </LegalSection>

      <LegalSection heading="2. Как използваме данните">
        <p>
          Данните се използват за поддръжка на акаунта Ви, запазване на
          напредъка в играта и подобряване на Услугата. Използваме анонимна
          аналитика, за да разберем как се ползва Услугата.
        </p>
      </LegalSection>

      <LegalSection heading="3. Споделяне с трети страни">
        <p>
          Не продаваме Вашите лични данни. Използваме доставчици на услуги
          (например Google Firebase) за удостоверяване, съхранение и аналитика,
          които обработват данни от наше име.
        </p>
      </LegalSection>

      <LegalSection heading="4. Съхранение и сигурност">
        <p>
          Прилагаме разумни мерки за защита на данните Ви. Съхраняваме данните
          толкова дълго, колкото е необходимо за предоставяне на Услугата.
        </p>
      </LegalSection>

      <LegalSection heading="5. Вашите права">
        <p>
          Имате право на достъп, корекция или изтриване на личните си данни. За
          заявки се свържете с нас на посочения по-долу имейл.
        </p>
      </LegalSection>

      <LegalSection heading="6. Контакт">
        <p>
          За въпроси относно поверителността: <a className="underline" href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>.
        </p>
      </LegalSection>
    </LegalLayout>
  );
}
